const ListWidgetMixin = {
    props: {
        id: {
            type: String | Number,
        },
        callbackUri: {
            type: String,
        },
        contextType: {
            type: String,
        },
        paramsForCallback: {
            type: Object,
            required: false
        },
        objectId: {
            type: String,
        },
        columnId: {
            type: String,
        }
    },
    methods: {
        /**
         * Get the current params for callback
         * @return {Object}
         */
        getCurrentParamsForCallback(item) {
            const params = this.paramsForCallback ? {...this.paramsForCallback}: {};

            // If we are already a child widget
            if (params.childWidgetIds) {
                // we add an array of child widgets
                params.childWidgetIds = [
                    ...params.childWidgetIds,
                    item.id
                ];
            } else {
                params.childWidgetIds = [item.id];
            }

            return params;
        }
    }
};

export default ListWidgetMixin;